import {
  APISRC
} from '../constants/Fetch'

export function postData(history, isFormWillBeRedirect, src, data, msgBlock) {
  const URL = APISRC + src;
  let siteHeaders = new Headers({
    // eslint-disable-next-line
    'X-CSRFToken': document.cookie.replace(/(?:(?:^|.*;\s*)csrftoken\s*\=\s*([^;]*).*$)|^.*$/, "$1")
  });
  fetch(URL, {
    method: 'POST',
    mode: 'cors',
    body: data,
    headers: siteHeaders
  })
  .then(response => response.json())
  .then(response => {
    if (msgBlock) {
      if (response.data) {
        msgBlock.classList.add('form__receivedMsg--error')

        for (const [key, value] of Object.entries(response.data)) {
          let msgError = document.createElement('div')
          msgError.innerHTML = value[0]
          msgBlock.appendChild(msgError)
        }
      } else if (!response.message) {
        if (isFormWillBeRedirect) {
          history.push('/success')
          return
        }

        msgBlock.innerHTML = "Данные успешно отправлены"
        if (msgBlock.classList.contains('form__receivedMsg--error')) {
          msgBlock.classList.remove('form__receivedMsg--error')
        }
        
      }
    }
  }).catch(e => {
    if(msgBlock) {
      msgBlock.classList.add('form__receivedMsg--error')
      msgBlock.innerHTML = "Произошла ошибка. Повторите попытку позже."
    }
  })
}


// WEBPACK FOOTER //
// ./src/utils/FormPost.js